"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeedmapsVerified = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
class WeedmapsVerified {
}
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", Number)
], WeedmapsVerified.prototype, "productId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], WeedmapsVerified.prototype, "productName", void 0);
exports.WeedmapsVerified = WeedmapsVerified;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2VlZG1hcHNWZXJpZmllZC5qcyIsInNvdXJjZVJvb3QiOiIuL3NyYy8iLCJzb3VyY2VzIjpbInBhY2thZ2VzL21vZGVscy9zcmMvd2VlZG1hcHNWZXJpZmllZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQUEscUNBQWlDO0FBRWpDLE1BQWEsZ0JBQWdCO0NBTTVCO0FBSkc7SUFBQyxJQUFBLGdCQUFNLEVBQUMsRUFBRSxRQUFRLEVBQUUsSUFBSSxFQUFFLENBQUM7O21EQUNUO0FBQ2xCO0lBQUMsSUFBQSxnQkFBTSxFQUFDLEVBQUUsUUFBUSxFQUFFLElBQUksRUFBRSxDQUFDOztxREFDUDtBQUx4Qiw0Q0FNQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENvbHVtbiB9IGZyb20gXCJ0eXBlb3JtXCI7XG5cbmV4cG9ydCBjbGFzcyBXZWVkbWFwc1ZlcmlmaWVkIHtcblxuICAgIEBDb2x1bW4oeyBudWxsYWJsZTogdHJ1ZSB9KVxuICAgIHByb2R1Y3RJZDogbnVtYmVyO1xuICAgIEBDb2x1bW4oeyBudWxsYWJsZTogdHJ1ZSB9KVxuICAgIHByb2R1Y3ROYW1lOiBzdHJpbmc7XG59Il19